export const EXCEPTIONAL_WORDS = ['tv', 't.v'];

export const isExceptionalWord = (text) => EXCEPTIONAL_WORDS.includes(text.toLowerCase());

export const mapInputValue = (text) => {
  if (text.toLowerCase() === 'tv') return 't.v';
  return text;
};
